import { limit as limitFirebase, where } from "firebase/firestore"
import { Collection, WhereField } from '../../shared/constants'
import { deleteDoc, getAllDocsByQueries } from './collectionBaseWorker'

export const getCamerasLPRLogsByIdentifierAndParkId = async ({ id, estacionamentoId }) => {
    const results = await getAllDocsByQueries({
        collection: Collection.CAMERAS_LPR_LOGS,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.CAMERA_ID, "==", id),
            limitFirebase(100)
        ]
    })
    return results.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds)
}

export const deleteCameraLogById = async ({ id }) => {
    await deleteDoc({ collection: Collection.CAMERAS_LPR_LOGS, id: id })
}